"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doRoadmapReagendar = exports.doRoadmapClientLocalFoto = exports.doRoadmapClientUpdate = exports.doRoadmapChecklistContactSave = exports.doRoadmapClientNewSave = exports.doRoadmapProspectingSave = exports.doRoadmapSend = exports.doRoadmapDateUpdate = exports.doRoadmapChecklistSave = exports.doRoadmapInventorySave = exports.doRoadmapMarketshareSave = exports.doRoadmapNotesSave = exports.doRoadmapCreate = exports.doRoadmapGet = exports.doRoadmapDeliverySave = exports.doRoadmapScheduledList = exports.doRoadmapInit = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const api_1 = __importDefault(require("constants/api"));
const constants_1 = require("constants/constants");
const doRoadmapInit = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.init",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapInit = doRoadmapInit;
const doRoadmapScheduledList = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.programados.listar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            page: params?.data.page,
            fecha: params?.data.fecha,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapScheduledList = doRoadmapScheduledList;
const doRoadmapDeliverySave = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.potencialdelivery.guardar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            hojaId: params?.data.hojaId,
            condicion: params?.data.condicion,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapDeliverySave = doRoadmapDeliverySave;
const doRoadmapGet = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.get",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            hojaId: params?.data.hojaId,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapGet = doRoadmapGet;
const doRoadmapCreate = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.crear",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            ...(params?.data ?? {}),
        },
    }));
    if (params?.fotolocal != undefined) {
        formData.append("fotolocal", params?.fotolocal);
    }
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapCreate = doRoadmapCreate;
const doRoadmapNotesSave = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.notas.guardar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            hojaId: params?.data.hojaId,
            notas: params?.data.notas,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapNotesSave = doRoadmapNotesSave;
const doRoadmapMarketshareSave = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.marketshare.guardar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            hojaId: params?.data.hojaId,
            share: params?.data.share,
            ventas: params?.data.ventas,
            marcas: params?.data.marcas,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapMarketshareSave = doRoadmapMarketshareSave;
const doRoadmapInventorySave = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.inventario.guardar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            hojaId: params?.data.hojaId,
            inventario: params?.data.inventario,
            share: params?.data.share,
            ventas: params?.data.ventas,
            marcas: params?.data.marcas,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapInventorySave = doRoadmapInventorySave;
const doRoadmapChecklistSave = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.checklist.guardar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            ...(params?.data ?? {}),
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapChecklistSave = doRoadmapChecklistSave;
const doRoadmapDateUpdate = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.fecha.actualizar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            hojaId: params?.data.hojaId,
            fecha: params?.data.fecha,
            hora: params?.data.hora,
            minuto: params?.data.minuto,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapDateUpdate = doRoadmapDateUpdate;
const doRoadmapSend = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.enviar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            hojaId: params?.data.hojaId,
            condicion: params?.data.condicion,
            checklist: params?.data.checklist,
            inventario: params?.data.inventario,
            share: params?.data.share,
            ventas: params?.data.ventas,
            marcas: params?.data.marcas,
            notas: params?.data.notas,
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapSend = doRoadmapSend;
const doRoadmapProspectingSave = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.prospeccion.guardar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            ...(params?.data ?? {}),
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapProspectingSave = doRoadmapProspectingSave;
const doRoadmapClientNewSave = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.clientenuevo.guardar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            hojaId: params?.data.hojaId,
            contactoNombre: params?.data.contactoNombre,
            contactoCorreo: params?.data.contactoCorreo,
            contactoDireccionFiscal: params?.data.contactoDireccionFiscal,
            contactoDireccionDespacho: params?.data.contactoDireccionDespacho,
            contactoZona: params?.data.contactoZona,
            geoLatitud: params?.data.geoLatitud,
            geoLongitud: params?.data.geoLongitud,
            geoDireccion: params?.data.geoDireccion,
            agenciero: params?.data.agenciero,
            categoria: params?.data.categoria,
            nombreComercial: params?.data.nombreComercial,
            almacenes: params?.data.almacenes,
            descuentos: params?.data.descuentos,
        },
    }));
    params?.data?.files?.forEach((item, index) => {
        formData.append(`fotolocal`, item);
    });
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapClientNewSave = doRoadmapClientNewSave;
const doRoadmapChecklistContactSave = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.checklistcontacto.guardar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            ...(params?.data ?? {}),
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapChecklistContactSave = doRoadmapChecklistContactSave;
const doRoadmapClientUpdate = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.cliente.actualizar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            ...(params?.data ?? {}),
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapClientUpdate = doRoadmapClientUpdate;
const doRoadmapClientLocalFoto = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.cliente.localfoto",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            ...(params?.data ?? {}),
        },
    }));
    if (params?.foto)
        formData.append("foto", params?.foto);
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapClientLocalFoto = doRoadmapClientLocalFoto;
const doRoadmapReagendar = async ({ params, callback, }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "hojaruta.reagendar",
        token: loginDataJSON.token,
        cliid: clientDataJSON.id,
        data: {
            ...(params?.data ?? {}),
        },
    }));
    callback?.onLoading?.(true);
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then(json => {
        switch (json.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json.msg);
                break;
        }
        callback?.onLoading?.(false);
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
        callback?.onLoading?.(false);
    });
};
exports.doRoadmapReagendar = doRoadmapReagendar;
